import React, { useEffect, useState, useCallback } from 'react'
import { Pagination } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { API, API_ROUTER } from '../../../../api'

import { Preloader } from '../../../../components/UI'
import UserItem from '../../../../components/list-items/components/userItem'

import styles from './styles.module.scss'

export const UsersList = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [usersList, setUsersList] = useState()
  const [pageTournament, setPageTournament] = useState(1)

  const getTournament = useCallback(() => {
    setIsLoading(true)
    API.request({
      ...API_ROUTER.follow.getFollowedUsers,
      pathKeys: {
        page: pageTournament,
        limit: 10,
      },
    })
      .then(res => {
        setUsersList(res)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }, [pageTournament])

  const handleChangeTournaments = (event, value) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setPageTournament(value)
  }

  useEffect(() => {
    getTournament()
  }, [getTournament])

  if (isLoading) {
    return <Preloader />
  }

  return (
    <section className={styles.calendarList}>
      {!usersList?.follows?.length && (
        <div className='empty-data'>
          <FormattedMessage id='calendar.noUsers' />
        </div>
      )}

      <article>
        <ul>
          {usersList?.follows?.map(items => (
            <UserItem {...items} key={items.id} />
          ))}
        </ul>
      </article>

      {!usersList?.paginator?.hasNextPage ||
        (usersList?.follows?.length > 9 && (
          <div className={styles.paginatorWrapper}>
            <Pagination
              classes={{ ul: styles.pagination }}
              count={usersList?.paginator?.lastPage || 0}
              page={usersList?.paginator?.currentPage ?? 1}
              onChange={handleChangeTournaments}
              variant='outlined'
            />
          </div>
        ))}
    </section>
  )
}

export default UsersList
